import _ from 'lodash';
import ManageAssets from './Icons/ManageAssets';
import ManageMob from './Icons/ManageMob';
import ManageProperties from './Icons/ManageProperties';
import ManageTasks from './Icons/ManageTasks';
import PropertyMap from './Icons/PropertyMap';
import PropertyArea from './Icons/PropertyArea';
import ManageLivestock from './Icons/ManageLivestock';
import DefaultProperty from './Icons/DefaultProperty';
import WeatherArea from './Icons/WeatherArea';
import marketplace from './Icons/marketplace.png';
import HealthSafety from './Icons/HealthSafety';
import Activity from './Icons/Activity'
import FileManager from './Icons/FileManager';
import SDS from './Icons/SDS';
import React from 'react';
import Visitors from './Icons/Visitors';
import Operations from './Icons/Operations';
import Spray from './Icons/Spray';
import Incidents from './Icons/Incidents';
import { commonHelper } from '@iso/lib/helpers/commonHelper';

// Ordered nav groups (matching the Figma). Each nav item carries a `group`
// key; the sidebar renders each group as a collapsible dropdown (all expanded
// by default). Items with no group (e.g. the active-property dashboard)
// render above the first group.
export const NAV_GROUPS = [
  { key: 'management', label: 'Management' },
  { key: 'safety', label: 'Safety' },
  { key: 'people', label: 'People' },
  { key: 'farm', label: 'Farm' },
  { key: 'operations', label: 'Operations' },
  { key: 'monitor', label: 'Monitor' },
];

export function options(properties, activeId = null, is_system_admin = null) {
  const options = (is_system_admin !== 1)
    ? [
        {
          key: 'operations/dashboard',
          label: 'Dashboard',
          leftIcon: <Operations />,
          group: 'operations',
        },
        {
          key: 'operations/taskboard',
          label: 'Taskboard',
          leftIcon: <ManageTasks />,
          group: 'operations',
        },
        {
          key: 'operations/planner',
          label: 'Planner',
          leftIcon: <PropertyArea />,
          group: 'operations',
        },
        {
          key: 'operations/team-schedule',
          label: 'Team Schedule',
          leftIcon: <Visitors />,
          group: 'operations',
        },
        {
          key: 'operations/time-tracker',
          label: 'Time Tracker',
          leftIcon: <Activity />,
          group: 'operations',
        },
        {
          key: 'operations/timesheets',
          label: 'Timesheets',
          leftIcon: <SDS />,
          group: 'operations',
        },
        {
          key: 'manage-properties',
          label: 'Properties',
          leftIcon: <ManageProperties />,
          group: 'management',
        },
        {
          key: 'map',
          label: 'Map',
          leftIcon: <PropertyMap />,
          group: 'management',
        },
        {
          key: 'corporate-reporting',
          label: 'Corporate Reporting',
          leftIcon: <Incidents />,
          group: 'management',
        },
        {
          key: 'file-manager',
          label: 'File Manager',
          leftIcon: <FileManager />,
          group: 'management',
        },
        {
          key: 'manage-areas',
          label: 'Areas',
          leftIcon: <PropertyArea />,
          group: 'farm',
        },
        {
          key: 'manage-assets',
          label: 'Assets',
          leftIcon: <ManageAssets />,
          group: 'farm',
        },
        {
          key: 'spray',
          label: 'sidebar.spray',
          leftIcon: <Spray />,
          group: 'farm',
        },
        {
          key: 'manage-tasks',
          label: 'Tasks',
          leftIcon: <ManageTasks />,
          group: 'farm',
        },
        {
          key: 'manage-mobs',
          label: 'Mobs',
          leftIcon: <ManageMob />,
          group: 'farm',
        },
        {
          key: 'manage-livestocks',
          label: 'Livestock',
          leftIcon: <ManageLivestock />,
          group: 'farm',
        },
        {
          key: 'health-safety',
          label: 'sidebar.healthSafety',
          leftIcon: <HealthSafety />,
          group: 'safety',
        },
        {
          key: 'safety-documents',
          label: 'Safety Documents',
          leftIcon: <FileManager />,
          group: 'safety',
        },
        {
          key: 'hazards',
          label: 'Hazards',
          leftIcon: <Incidents />,
          group: 'safety',
        },
        {
          key: 'safe-farm',
          label: 'sidebar.safeFarm',
          leftIcon: <ManageAssets />,
          group: 'safety',
        },
        {
          key: 'incidents',
          label: 'Incidents',
          leftIcon: <Incidents />,
          group: 'safety',
        },
        {
          key: 'sds',
          label: 'Safety Data Sheets',
          leftIcon: <SDS />,
          group: 'safety',
        },
        {
          key: 'manage-visitor',
          label: 'sidebar.manageVisitor',
          leftIcon: <Visitors />,
          group: 'people',
        },
        {
          key: 'contractors',
          label: 'Contractors',
          leftIcon: <Visitors />,
          group: 'people',
        },
        {
          key: 'training-module',
          label: 'Training',
          leftIcon: <HealthSafety />,
          group: 'people',
        },
        {
          key: 'weather',
          label: 'Weather',
          leftIcon: <WeatherArea />,
          group: 'monitor',
        },
        {
          key: 'manage-sensors',
          label: 'Sensors',
          leftIcon: <ManageProperties />,
          group: 'monitor',
        },
        {
          key: 'activity',
          label: 'Activity',
          leftIcon: <Activity />,
          group: 'monitor',
        },
      ]
    : [
        {
          key: 'admin-dashboard',
          label: 'sidebar.adminDashboard',
          leftIcon: <ManageTasks />,
        },
        {
          key: 'manage-product-category',
          label: 'sidebar.manageProductCaregory',
          leftIcon: <ManageTasks />,
        },
        {
          key: 'manage-product',
          label: 'sidebar.manageProduct',
          leftIcon: <ManageTasks />,
        },
        {
          key: 'manage-property',
          label: 'sidebar.manageProperty',
          leftIcon: <ManageTasks />,
        },
        {
          key: 'manage-corporate-groups',
          label: 'sidebar.manageCorporate',
          leftIcon: <ManageTasks />,
        },
        {
          key: 'manage-entra-sso',
          label: 'Entra SSO',
          leftIcon: <ManageTasks />,
        },
        {
          key: 'manage-user',
          label: 'sidebar.manageUser',
          leftIcon: <ManageTasks />,
        },
        {
          key: 'manage-sample-avatar',
          label: 'sidebar.manageSampleAvatar',
          leftIcon: <ManageTasks />,
        },
        {
          key: 'manage-form',
          label: 'sidebar.manageForm',
          leftIcon: <ManageTasks />,
        },
        {
          key: 'category-form',
          label: 'sidebar.categoryForm',
          leftIcon: <ManageTasks />,
        },
        {
          key: 'manage-library-forms',
          label: 'sidebar.manageLibraryForms',
          leftIcon: <ManageTasks />,
        },
        {
          key: 'manage-agent',
          label: 'sidebar.manageAgent',
          leftIcon: <ManageTasks />,
        },
        {
          key: 'manage-sensor',
          label: 'sidebar.manageSensor',
          leftIcon: <ManageTasks />,
        },
        {
          key: 'manage-emergency-response',
          label: 'sidebar.manageEmergencyResponse',
          leftIcon: <ManageTasks />,
        },
      ];

  const activeProperty = commonHelper.getActiveProperty();
  if (activeProperty && is_system_admin !== 1) {
    options.unshift({
      key: 'dashboard',
      label: activeProperty.name,
      leftIcon: <DefaultProperty />,
    });
  }

  return options;
}
